import { apiRequest } from '../lib/apiClient';

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

export const getUserByExternalId = (externalId, token) =>
  apiRequest(`/users/${externalId}`, { headers: authHeaders(token) }, 'Failed to load user.');

export const getCurrentUser = (token) =>
  apiRequest('/users/me', { headers: authHeaders(token) }, 'Failed to load user.');

export const updateCurrentUser = (payload, token) =>
  apiRequest(
    '/users/me',
    {
      method: 'PUT',
      headers: {
        ...authHeaders(token),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    'Failed to update user.'
  );

export const deleteCurrentUser = (token) =>
  apiRequest(
    '/users/me',
    {
      method: 'DELETE',
      headers: authHeaders(token),
    },
    'Failed to delete account.'
  );

export const registerUser = (payload) =>
  apiRequest(
    '/users/register',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    'Registration failed',
    { includeStatus: true }
  );

export const loginUser = (payload) =>
  apiRequest(
    '/users/login',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    'Login failed'
  );

export const logoutUser = () =>
  apiRequest(
    '/users/logout',
    {
      method: 'POST',
    },
    'Logout failed'
  );

export const verifyEmail = (payload) =>
  apiRequest(
    '/users/verify-email',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    'Email verification failed'
  );

export const requestPasswordReset = (payload) =>
  apiRequest(
    '/users/request-password-reset',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    'Password reset request failed'
  );

export const resetPassword = (payload) =>
  apiRequest(
    '/users/reset-password',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    'Password reset failed'
  );
